<template>
    <div>
        <view-analytics-supplyers
            :currentRoute="currentRoute"
            :currentTitle="'Оператор'"
            :tableTabs="tableTabs"
            :table-first-column="groupingEntityMulti"
        />
    </div>
</template>

<script>
/** Пока что вывожу клиент условия через операторов. В будущем компоненты могут измениться */
import ViewAnalyticsSupplyers from './ViewAnalyticsSupplyers';
import schemeApi from '../../schemes/schemeApi';
import mixinGroupingEntity from "@/mixins/mixinGroupingEntity";
import schemeAnalytics from "../../schemes/schemeAnalytics";
let {routeAnalyticsSupplyers} = schemeApi;
let {supplyersAnalyticsTabs} = schemeAnalytics;
export default {
    name: 'ViewAnalyticsSupplierCondition',
    components: {
        ViewAnalyticsSupplyers
    },
    mixins: [
      mixinGroupingEntity
    ],
    /**
     * Входные данные компонента
     * @property {string} currentRoute - текущий маршрут
     * @property {Object} tableTabs - табы
     */
    data: () => ({
        currentRoute: routeAnalyticsSupplyers,
        tableTabs: supplyersAnalyticsTabs,
    }),
    watch: {
      groupingEntitySingle(){
        this.tableTabs.default.title = this.groupingEntitySingle ? 'Формат - ' + this.groupingEntitySingle : '';
        this.tableTabs.back.title = this.groupingEntitySingle ? this.groupingEntitySingle + ' - Формат' : '';
      }
    }
}
</script>

<style lang="scss" scoped>

</style>